import { useQuery } from '@tanstack/react-query';

import { CustomAttributeType } from '@/modules/common/types/custom-attribute';
import { getCustomAttributesForUsers } from '@/modules/team/api/custom-attributes.api';

export const CUSTOM_ATTRIBUTES_USER_QUERY_KEY = ['custom-attributes', 'USER'];

// Frontend currently supports only single- and multi-select custom attributes.
// Other backend types (text, number, boolean, date) are filtered out here so they
// never reach the detail form or the filter configs. Remove an entry once a type
// is fully supported across rendering, mapping, and filtering.
const SUPPORTED_CUSTOM_ATTRIBUTE_TYPES: ReadonlySet<CustomAttributeType> = new Set([
  CustomAttributeType.Select,
  CustomAttributeType.MultiSelect,
]);

interface UseCustomAttributesParams {
  /**
   * Gate the request. Defaults to `true` so existing callers (whose screens are
   * already route-guarded) are unaffected. The planner passes a permission check
   * here so the endpoint isn't called for users without planner access (OPS-1561).
   */
  enabled?: boolean;
}

export const useCustomAttributes = ({ enabled = true }: UseCustomAttributesParams = {}) => {
  return useQuery({
    queryKey: CUSTOM_ATTRIBUTES_USER_QUERY_KEY,
    queryFn: getCustomAttributesForUsers,
    staleTime: 5 * 60 * 1000,
    enabled,
    select: attributes =>
      attributes.filter(attr => SUPPORTED_CUSTOM_ATTRIBUTE_TYPES.has(attr.type)),
  });
};
